import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setElement as setElementInLayoutGroup
} from '../redux/layoutGroups'

export default function * requestRemoveElementFromLayoutGroup (action) {
  const { layoutId, id, layoutGroupId } = action.payload

  const optimisticAction = yield optimisticPut(setElementInLayoutGroup({
    layoutId,
    elementId: id,
    name,
    isBusy: true
  }))

  try {
    yield call(apiAction, 'RemoveElementFromLayoutGroup', {
      layoutId,
      id,
      groupId: layoutGroupId
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
